import { CostSavingChartDataWithDynamicEms, DynamicEmsData, EmsBatteryMode } from '../../types'
import { getGradientOffset } from '../../utils'

/**
 * Determine the vertical endpoint of the battery mode gradients. Due to how the Recharts library operates internally, recurring modes require a specific workaround to be handled correctly.
 */
export const useGradientY2Values = (
  dynamicEmsData: DynamicEmsData[],
  dataWithBatteryMode: CostSavingChartDataWithDynamicEms[],
  domain: number[],
  showDynamicEmsReferenceAreas?: boolean
): {
  y2GridCharge: number
  y2NormalOperation: number
  y2BlockDischarging: number
} => {
  if (!showDynamicEmsReferenceAreas) return { y2GridCharge: 0, y2NormalOperation: 0, y2BlockDischarging: 0 }
  const getIsLastModeDoubled = (dynamicEmsData: DynamicEmsData[]): boolean => {
    if (dynamicEmsData.length === 0) return false

    const lastMode = dynamicEmsData.at(-1)?.emsBatteryMode
    let isLastModeDoubled = false
    for (let i = 0; i < dynamicEmsData.length - 1; i++) {
      if (dynamicEmsData[i].emsBatteryMode === lastMode) isLastModeDoubled = true
    }
    return isLastModeDoubled
  }

  const isLastModeDoubled = getIsLastModeDoubled(dynamicEmsData)

  const getLargestPowerPriceForMode = (mode: EmsBatteryMode): number => {
    let largest = 0
    for (const item of dataWithBatteryMode) {
      if (!item.consumptionPrice) continue
      if (item.batteryMode === mode && item.consumptionPrice > largest) largest = item.consumptionPrice
    }
    return largest
  }

  const y2GridCharge = getGradientOffset(
    dynamicEmsData,
    EmsBatteryMode.GridCharge,
    getLargestPowerPriceForMode(EmsBatteryMode.GridCharge),
    domain[0],
    isLastModeDoubled
  )
  const y2NormalOperation = getGradientOffset(
    dynamicEmsData,
    EmsBatteryMode.NormalOperation,
    getLargestPowerPriceForMode(EmsBatteryMode.NormalOperation),
    domain[0],
    isLastModeDoubled
  )
  const y2BlockDischarging = getGradientOffset(
    dynamicEmsData,
    EmsBatteryMode.BlockDischarging,
    getLargestPowerPriceForMode(EmsBatteryMode.BlockDischarging),
    domain[0],
    isLastModeDoubled
  )

  return { y2GridCharge, y2NormalOperation, y2BlockDischarging }
}
